module.exports = __webpack_public_path__ + "media/images/svgs/gps-fdc806fc683f228ecf96c538799c47cc.svg";